module.exports = __webpack_public_path__ + "media/new/contact-query-a73f6a15.png";